import React from "react"
import { css } from "@emotion/core"
import { Link } from "gatsby"

import * as dsm from "../../../utils/dsm"
import * as mixins from "../../../utils/mixins"

export function DisplayOptionContainer({ children, styles = "" }) {
  return (
    <div
      css={css`
        margin-bottom: 1.5rem;

        &:last-child {
          margin-bottom: 0;
        }

        ${mixins.device.tablet} {
          display: flex;
          height: 100%;
          max-height: 14rem;

          &:nth-of-type(even) {
            flex-direction: row-reverse;
          }
        }

        ${styles}
      `}
    >
      {children}
    </div>
  )
}

export function DisplayImageCont({ children, styles = "" }) {
  return (
    <div
      css={css`
        max-height: 12rem;

        ${mixins.device.tablet} {
          width: 50%;
          max-height: inherit;
        }

        ${styles}
      `}
    >
      {children}
    </div>
  )
}

export function DisplayContentCont({ children, styles = "" }) {
  return (
    <div
      css={css`
        background: ${dsm.colors.greenGradient.base};
        padding: 0.75rem;

        ${mixins.device.tablet} {
          width: 50%;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 1rem;
          padding-bottom: 0rem;
        }

        ${mixins.device.laptop} {
          padding: 1rem 1.25rem;
          padding-bottom: 0;
        }

        ${styles}
      `}
    >
      {children}
    </div>
  )
}

export function DisplayContentTitle({ children, styles = "" }) {
  return (
    <h2
      css={css`
        margin-bottom: 0.5rem;
        ${dsm.fonts.display};
        ${dsm.fonts.textShadow.black};
        font-size: 1.15rem;
        color: white;

        ${mixins.device.mobileM} {
          font-size: 1.25rem;
        }

        ${mixins.device.mobileX} {
          font-size: 1.35rem;
        }

        ${mixins.device.tablet} {
          font-size: 1.25rem;
        }

        ${mixins.device.laptop} {
          font-size: 1.35rem;
        }

        ${styles}
      `}
    >
      {children}
    </h2>
  )
}

export function DisplayContentBody({ children, styles = "" }) {
  return (
    <p
      css={css`
        margin-bottom: 0.75rem;

        ${dsm.fonts.body}
        font-weight: 600;
        color: white;

        ${mixins.device.mobileL} {
          font-size: 1.1rem;
        }

        ${mixins.device.tablet} {
          margin-bottom: 1rem;
        }

        ${mixins.device.laptop} {
          width: 95%;
          font-size: 1.15rem;
        }

        ${styles}
      `}
    >
      {children}
    </p>
  )
}

export function DisplayOptionLearnMore({ to, styles = "", children }) {
  return (
    <Link
      css={css`
        width: 100%;
        padding: 1rem 3rem 1rem 0;
        ${dsm.fonts.display}
        font-weight: bolder;
        color: #53b3ec;
        ${dsm.fonts.textShadow.black};
        transition: color 0.3s ease-in-out;

        &:hover {
          color: #31abf3;
          transition: color 0.3s ease-in-out;
        }

        ${mixins.device.tablet} {
          font-size: 1.05rem;
          padding: 0;
          margin-bottom: 0.75rem;
          font-size: 1rem;
          height: 1.75rem;
          display: flex;
          align-items: center;
        }

        ${styles}
      `}
      to={to}
    >
      {children}
    </Link>
  )
}
